import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from '@core/core.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NAPA_DEFAULT_DATEPICKER_PROVIDERS } from '@core/constants/datepicker.constants';
import { StoreModule } from '@store/store.module';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { QuillModule } from 'ngx-quill';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CoreModule,
    BrowserAnimationsModule,
    StoreModule,
    InlineSVGModule.forRoot(),
    AngularSvgIconModule.forRoot(),
    QuillModule,
  ],
  providers: [...NAPA_DEFAULT_DATEPICKER_PROVIDERS],
  bootstrap: [AppComponent],
})
export class AppModule {}
